import createBehavior from '@js/functions/createBehavior.js';
import { importLibrary, setOptions } from '@googlemaps/js-api-loader';
import getCurrentMediaQuery from '@area17/a17-helpers/src/utility/getCurrentMediaQuery.js';

let mapsApiPromise;

function loadGoogleMapsApi(config) {
  if (!mapsApiPromise) {
    setOptions({
      key: config.key,
      mapIds: [config.id],
      v: 'weekly',
    });

    mapsApiPromise = Promise.all([importLibrary('maps'), importLibrary('marker')]);
  }

  return mapsApiPromise;
}

const directionBehavior = createBehavior(
  'direction',
  {
    loadGoogleMapApi() {
      loadGoogleMapsApi(this.mapConfig).then(([mapsLibrary, markerLibrary]) => {
        this.Map = mapsLibrary.Map;
        this.AdvancedMarkerElement = markerLibrary.AdvancedMarkerElement;
        this.buildMap();
      }).catch(function (error) {
        console.error(error);
      });
    },
    bindEvents() {
      window.addEventListener('resized', this.resizedHandler, false);
    },
    buildMap() {
      this.map = new this.Map(this.getChild('map'), {
        center: this.mapConfig.center,
        mapId: this.mapConfig.id,
        zoom: 14,
      });

      // Add custom markers.
      this.addMarkers();

      // Update zoom.
      this.updateZoom();
    },
    addMarkers() {
      Object.values(this.mapConfig.markers).forEach((marker) => {
        const icon = document.createElement('img');
        icon.src = marker.icon;
        icon.alt = '';

        new this.AdvancedMarkerElement({
          position: marker.position,
          content: icon,
          map: this.map
        });
      });
    },
    resizedHandler() {
      // Get breakpoint.
      this.breakpoint = getCurrentMediaQuery();

      // Update zoom.
      this.updateZoom();
    },
    updateZoom() {
      // Based on breakpoint, adjust zoom.
      if (this.map) {
        if (this.breakpoint === 'small') {
          this.map.setZoom(12)
        } else if (this.breakpoint === 'medium') {
          this.map.setZoom(13);
        } else {
          this.map.setZoom(14);
        }
      }
    }
  },
  {
    init() {
      this.mapConfig = JSON.parse(this.options.config);
      this.AdvancedMarkerElement = null;
      this.Map = null;
      this.map = null;
      this.breakpoint = getCurrentMediaQuery();

      this.loadGoogleMapApi();
      this.bindEvents();
    },
    destroy() {
      window.removeEventListener('resized', this.resizedHandler);
    }
  }
);

export default directionBehavior;
